import React, { useEffect } from "react";
import { Projects } from "../../components/ui/Projects";
import { SiteFrame } from "../../components/ui/SiteFrame";
import Mixpanel from "../../lib/mixpanel";
import Seo from "../../components/Seo";

export default function ProjectsPage() {
  useEffect(() => {
    Mixpanel.trackProjects();
  }, []);

  return (
    <SiteFrame>
      <Seo
        title="Projects"
        path="/projects"
        description="A selection of projects built by Krushil Amrutiya across software, web, and side ventures."
      />
      <Projects />
    </SiteFrame>
  );
}
